/**
 * 存储全局的路由信息
 */
import { observable, action } from 'mobx'

class UIStore {

  @observable menuDisplay = false
  @observable headerDisplay = false

  @action mainFull () {
    this.menuDisplay = false
    this.headerDisplay = false
  }
}

const uiStore = new UIStore()

export default uiStore



// WEBPACK FOOTER //
// ./src/wbap-core-commit/store/UIStore.js